import { request } from "../../../services/api"
import type { BaseApiResponse, BasePagination } from "../../../types/api.ts"
import type {
  MessageDetail,
  MessageRow,
  Overview
} from "../types/messages.types.ts"

const BASE_URL = "/communication"

export const getMessages = (params: Record<string, string | number>) =>
  request.api.get<BasePagination<MessageRow>, BaseApiResponse<void>>(
    `${BASE_URL}/messages/`,
    params
  )

export const getMessage = (id: string) =>
  request.api.get<MessageDetail, BaseApiResponse<void>>(
    `${BASE_URL}/messages/${id}/`
  )

export const getOverview = (period: string) =>
  request.api.get<Overview, BaseApiResponse<void>>(`${BASE_URL}/overview/`, {
    period
  })

export interface MessageFilterOptions {
  senders: Array<{ id: string; name: string }>
  campaigns: Array<{
    id: string
    subject: string
    channel: "email" | "sms"
    created: string
  }>
}

export const getMessageFilterOptions = () =>
  request.api.get<MessageFilterOptions, BaseApiResponse<void>>(
    `${BASE_URL}/messages/filter-options/`
  )

export const answerReply = (replyId: string, body: string) =>
  request.api.post<BaseApiResponse<{ id: string }>, BaseApiResponse<void>>(
    `${BASE_URL}/replies/${replyId}/answer/`,
    { body }
  )
